// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.numberSelectorOption {
  padding: 4px 9px;
  background: transparent;
  border-top: 1px solid #4c68a4;
  border-bottom: 1px solid #4c68a4;
  border-left: 1px solid #4c68a4;
  border-right: none;
  color: #4c68a4;
  cursor: pointer;
  line-height: 2.5em;
}
@media screen and (min-width: 420px) {
  .numberSelectorOption {
    padding: 4px 12px;
  }
}
.numberSelectorOption.active {
  color: #fff;
  background-color: #4c68a4;
}
.numberSelectorOption:first-of-type {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.numberSelectorOption:last-of-type {
  border-right: 1px solid #4c68a4;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.has-error .numberSelectorOption {
  background-color: rgba(255, 56, 96, 0.05);
}
.has-error .numberSelectorOption.active {
  color: rgba(255, 56, 96, 0.05);
}

.text {
  display: block;
  border: none !important;
  color: #333;
  white-space: nowrap;
}
.text:first-of-type {
  align-self: start;
}
.text:last-of-type {
  align-self: end;
}

.numberSelectorOptionExcept {
  padding: 4px 8px;
  border: 1px solid #4c68a4;
  color: #4c68a4;
  margin-right: 8px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 5px;
  background: transparent;
}
.numberSelectorOptionExcept.active {
  color: #fff;
  background-color: #4c68a4;
}
.has-error .numberSelectorOptionExcept {
  background-color: rgba(255, 56, 96, 0.05);
}
.has-error .numberSelectorOptionExcept.active {
  color: #fff;
  background-color: #4c68a4;
}`, "",{"version":3,"sources":["webpack://./packages/react-hook-schema/standard/src/lib/numberSelector.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAToB;EAYpB,eAAA;EAEA,kBAAA;AAJF;AAKE;EAbF;IAcI,iBAAA;EAFF;AACF;AAGE;EACE,WAAA;EACA,yBApBkB;AAmBtB;AAGE;EACE,2BAAA;EACA,8BAAA;AADJ;AAGE;EACE,+BAAA;EACA,4BAAA;EACA,+BAAA;AADJ;AAGE;EACE,yCAAA;AADJ;AAEI;EACE,8BAAA;AAAN;;AAIA;EACE,cAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AADF;AAEE;EACE,iBAAA;AAAJ;AAEE;EACE,eAAA;AAAJ;;AAGA;EACE,gBAAA;EACA,yBAAA;EACA,cArDoB;EAsDpB,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EAEA,uBAAA;AADF;AAEE;EACE,WAAA;EACA,yBA/DkB;AA+DtB;AAGE;EACE,yCAAA;AADJ;AAII;EAEE,WAAA;EACA,yBAzEgB;AAsEtB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
